import { Platform } from 'react-native';
import { ColumnModel, FilterModel } from '../../filter';

export const AlertsManagementFilterKey = 'ALERTS_MANAGEMENT_FILTER';
export const AlertsManagementListOrderKey = 'ALERTS_MANAGEMENT_LIST_ORDER_KEY';

export const AlertsManagementFilterBaseColumns = [
  'name',
  'routineName',
  'assetName',
  'groupName',
  'productName',
  'assetAlerts',
  'lastAlertDate',
  'nextAlertDate',
  'createdAt',
];

export class AlertsManagementFilterModel implements FilterModel, ColumnModel {
  keyword?: string;
  columns?: string[];
  workspaceId?: string;

  constructor(data?: any) {
    this.keyword = data?.keyword;
    this.workspaceId = data?.workspaceId;
    this.columns =
      data?.columns ||
      (Platform.OS === 'web'
        ? [
            'name',
            'routineName',
            'assetName',
            'groupName',
            'productName',
            'assetAlerts',
            'lastAlertDate',
            'nextAlertDate',
            'createdAt',
          ]
        : []);
  }

  public getFilter(): any {
    const filter = {} as any;

    if (this.workspaceId) {
      filter.workspaceId = this.workspaceId;
    }

    if (this.keyword) {
      filter.keyword = this.keyword;
    }

    return filter;
  }

  public getColumnsCount(): number {
    let count = 0;

    if (this.columns) {
      count += this.columns.length;
    }

    return count;
  }
}
